import UIComponent from '../ui/component';
import goals from "../utils/goals";

export class OperationSubscription extends UIComponent {
    init() {
        this.offer;
        this.payBtn.on("click", this.onPayBtnClick.bind(this));
    }

    update(data) {
        this.amount = data['amount_formatted'];
        this.payBtn.amount = data['amount_formatted'];
        this.offer = data['id'];
        this.pricePerMin = data?.formatted_minute_cost ?? '';
    }

    onPayBtnClick(e) {
        e.preventDefault();

        this.emit('payClick', { offer: this.offer });
        goals.reach('payperminute_selected');
    }
}
